const H5 = ({ children, additionalclasses }) => (
  <span
    className={`custom-text-grey-500  poppins-bold text-[24px] leading-[28.8px] tracking-[-0.48px]`}
  >
    {children}
  </span>
);

export default H5;
